export const DOMESTIC_SEARCH_KEY = 'Vietnam'

export const LIST_STATUS = {
  ACTIVE: 1,
  TERMINATED: 2,
  SUSPENDED: 3,
  OTHERS: 4,
  REVOKED: 5,
  BRC_REVOKED: 6,
  DISSOLVED: 7,
  BANKRUPT: 8,
  NOT_OPERATING: 9,
}

export const LIST_LOCATION_TYPE = {
  HEADQUARTERS: 1,
}

export const STATUS_COLOR = {
  [LIST_STATUS.ACTIVE]: '#3DA967',
  [LIST_STATUS.BANKRUPT]: '#C8781A',
  [LIST_STATUS.BRC_REVOKED]: '#F58B00',
  [LIST_STATUS.DISSOLVED]: '#3A414B',
  [LIST_STATUS.NOT_OPERATING]: '#E8B714',
  [LIST_STATUS.OTHERS]: '#9C9C9C',
  [LIST_STATUS.REVOKED]: '#D375AE',
  [LIST_STATUS.SUSPENDED]: '#EC626D',
  [LIST_STATUS.TERMINATED]: '#E03643',
}

export const LOCATION_COLOR = {
  [LIST_LOCATION_TYPE.HEADQUARTERS]: '#E0E0E0',
}

export const DEFAULT_CODE = 'VN'
